import { render, staticRenderFns } from "./Ongkir.vue?vue&type=template&id=72ce88d0&scoped=true"
import script from "./Ongkir.vue?vue&type=script&lang=js"
export * from "./Ongkir.vue?vue&type=script&lang=js"
import style0 from "../assets/login.css?vue&type=style&index=0&id=72ce88d0&prod&scoped=true&lang=css&external"
import style1 from "./Ongkir.vue?vue&type=style&index=1&id=72ce88d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ce88d0",
  null
  
)

export default component.exports